import { render, staticRenderFns } from "./saleBottom.vue?vue&type=template&id=49d7e0bd&scoped=true&"
import script from "./saleBottom.vue?vue&type=script&lang=js&"
export * from "./saleBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d7e0bd",
  null
  
)

export default component.exports